// import components
import { Icon } from '@sdb/planning-ui';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

// import styles
import { IconContainer } from 'components/mrp/mrp.styles';

const IconWithContainer = ({
  iconColor,
  icon
}: {
  iconColor: string;
  icon?: IconType;
}) => (
  <IconContainer iconColor={iconColor} customIconSize={20}>
    {icon && <Icon type={icon} />}
  </IconContainer>
);

export default IconWithContainer;
